module.exports = __webpack_public_path__ + "static/img/model-bg18.4f05c7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg18.jpg
// module id = ItcS
// module chunks = 0